import type { AppointmentReport } from '../../api/types';
import { fmtDateTime } from '../format';
import { hasNotes } from './reportSteps';

// Terminbericht auf der Terminseite (nach dem Abschicken): Bericht in sauberen Zeilen und die KI-Auswertung der Notizen –
// Zusammenfassung, nächster Schritt und welche Rückfragen daraus entstanden sind.
export function ReportCard({ report }: { report: AppointmentReport }) {
  const text = (report.summary ?? '').replace(/^Terminbericht\n/, '');
  const ai = report.ai_insights;
  return (
    <section className="card report-card" aria-labelledby="report-title">
      <div className="section-head">
        <h2 id="report-title">Terminbericht</h2>
        <span className="muted small">
          {report.author_name ?? 'Makler'} · {fmtDateTime(report.submitted_at)}
        </span>
      </div>
      {text && <p className="report-text">{text}</p>}
      {ai ? (
        <div className="report-ai">
          <h3>KI-Auswertung der Notizen</h3>
          {ai.summary && <p>{ai.summary}</p>}
          {ai.next_step && (
            <p>
              <strong>Nächster Schritt:</strong> {ai.next_step}
            </p>
          )}
          {ai.created && ai.created.length > 0 ? (
            <>
              <p>
                <strong>Angelegt:</strong>
              </p>
              <ul>
                {ai.created.map((c) => (
                  <li key={c}>{c}</li>
                ))}
              </ul>
            </>
          ) : (
            <p className="muted small">Keine weiteren Aufgaben nötig.</p>
          )}
        </div>
      ) : (
        hasNotes(report.answers) && <p className="muted small">Die KI wertet die Notizen aus …</p>
      )}
    </section>
  );
}
